const allStatsForGame = () => {
    return {
        goals:0,
        throws:0,
        defensiveRebounds:0,
        offensiveRebounds:0,
        dribbles:0,
        faults:0,
        snitchs:0,
        saves:0,
        concededGoals:0,
        assists:0,
        bLost:0,
        bStolen:0,
        bludgersThrown:0,
        bludgersHit:0,
        bludgersSaves:0,
        expulsions:0,
        progressions:0,
        jugadas:0
    }
}

export default allStatsForGame